import { Body, Box, BoxProps } from '@hover/blueprint';
import React, { Dispatch, FC, SetStateAction } from 'react';

interface Props extends BoxProps {
  setPageNumber: Dispatch<SetStateAction<number>>;
  currentPageNumber: number;
  totalPagesNumber: number | null;
}

const PaginationPagesMobile: FC<Props> = props => {
  const { setPageNumber, currentPageNumber, totalPagesNumber } = props;

  const setToLast = () => {
    setPageNumber(totalPagesNumber || 1);
  };

  const handleNextPage = () => {
    setPageNumber(currentPageNumber + 1);
  };

  return (
    <Box
      display={{ base: 'flex', tablet: 'none' }}
      alignItems="center"
      px={600}
    >
      <Body
        cursor="pointer"
        size={600}
        color="brandNavy.500"
        onClick={handleNextPage}
      >
        {currentPageNumber}
      </Body>
      <Body mx={200} size={600}>
        /
      </Body>
      <Body size={600} cursor="pointer" onClick={setToLast}>
        {totalPagesNumber}
      </Body>
    </Box>
  );
};

export default PaginationPagesMobile;
